<template>
    <div class="font-sans antialiased leading-tight p-0 xs:-mr-5 w-full overflow">
        <app-header></app-header>
        <div class="mb-6">
            <div class="bg-grey-lightest">
                <div class="container mx-auto px-6 pt-32">
                    <h1 class="text-center text-black font-semibold text-4xl mb-12">
                        Условия использования
                    </h1>
                    <div class="pb-10">
                        <p class="mb-4">Настоящие Условия использования регулируют порядок доступа и использования мобильного приложения (далее — «Приложение»), предоставляемого нашей компанией (далее — «Мы»).</p>

                        <h2 class="mb-4">1. Принятие условий</h2>
                        <p class="mb-4">Используя Приложение, вы соглашаетесь с настоящими Условиями. Если вы не согласны с какими-либо из положений, пожалуйста, не используйте Приложение.</p>

                        <h2 class="mb-4">2. Использование Приложения</h2>
                        <ul class="mb-4">
                            <li>Вы обязуетесь использовать Приложение только в законных целях;</li>
                            <li>Вы не имеете права использовать Приложение для размещения незаконной, оскорбительной или вредоносной информации;</li>
                            <li>Вы не должны предпринимать действий, которые могут нарушить работу Приложения или доступ к нему других пользователей.</li>
                        </ul>

                        <h2 class="mb-4">3. Интеллектуальная собственность</h2>
                        <p class="mb-4">Все права на контент, дизайн, код и функциональность Приложения принадлежат нам или нашим лицензиарам. Копирование, распространение или использование материалов Приложения без разрешения запрещено.</p>

                        <h2 class="mb-4">4. Ограничение ответственности</h2>
                        <p class="mb-4">Мы не несем ответственности за любые убытки, прямые или косвенные, возникшие в результате использования или невозможности использования Приложения.</p>

                        <h2 class="mb-4">5. Изменения условий</h2>
                        <p class="mb-4">Мы оставляем за собой право изменять данные Условия в любое время. Обновленные Условия будут опубликованы в Приложении или на официальном сайте.</p>

                        <h2 class="mb-4">6. Прекращение использования</h2>
                        <p class="mb-4">Мы можем прекратить или ограничить доступ к Приложению без предварительного уведомления, если вы нарушите данные Условия.</p>

                        <h2 class="mb-4">7. Возрастные ограничения</h2>
                        <p class="mb-4">Если вы моложе 13 лет, вы должны получить согласие родителей или законных представителей для использования Приложения. Мы не собираем сознательно личную информацию у детей младше 13 лет.</p>

                        <h2 class="mb-4">8. Контактная информация</h2>
                        <p>Если у вас есть вопросы по настоящим Условиям, пожалуйста, свяжитесь с нами: <a href="mailto:lingua.ai.mobile.app@gmail.com">lingua.ai.mobile.app@gmail.com</a></p>
                    </div>
                </div>
            </div>
            <svg id="curveDownColor" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
                <path style="fill: #f8fafc;" d="M0 0 C 50 100 80 100 100 0 Z" />
            </svg>
        </div>
        <app-download></app-download>
        <app-footer></app-footer>
    </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import AppDownload from "./components/AppDownload.vue";

export default {
    components: {
        AppHeader,
        AppFooter,
        AppDownload
    }
};
</script>

<style>
@tailwind preflight;
@tailwind components;
@tailwind utilities;
</style>
